module.exports = __webpack_public_path__ + "media/images/logo-0b5e26ee0efd335bf348617a5dea92bf.png";